/**
 * The property's real logo — a circular seal with "nbh" and the property's own
 * flourish above it. Extracted from the source artwork (a JPEG on a white ground)
 * by matting against that white, so the PNG here carries the exact geometry of the
 * original at a transparent background rather than a redrawn approximation.
 *
 * Recoloured, not redrawn: the source's own ink (a muted sage-olive ring and
 * letterforms, a richer mustard-gold accent on the "u" and the flower's centre
 * petal) measures 1.48:1 and 2.45:1 against this app's header green — both under
 * the 3:1 floor the app already established for non-text marks on that green
 * (see the gold-on-light note in index.css). Recoloured into the app's own
 * already-verified gold family instead: the ring and letterforms in gold-light
 * (5.50:1 on the header), the "u" and flower centre in gold proper (3.31:1, the
 * documented floor) — the same two-tone relationship the original draws, in
 * colours already proven to read on this property's own dark surfaces.
 *
 * One definition, two sizes (the header's small mark and the login hero's large
 * one), so the two never drift into two different seals by accident.
 */
export function BrandMark({ size = 'size-10' }: { size?: string }) {
  return (
    <img
      src="/brand/nbh-logo.png"
      alt=""
      className={`shrink-0 object-contain ${size}`}
    />
  );
}
